import { inject } from 'vue';

export default function useTimeFormat() {
  const is24Hour = inject('is24Hour', undefined);
  const moment = inject('moment');

  function convertTimeFormat(value) {
    if (is24Hour) return value;

    return moment(value, 'HH:mm').locale('en').format('h:mm A');
  }

  return {
    convertTimeFormat,
  };
}
